module.exports = __webpack_public_path__ + "static/media/480.623f9914.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-seed/light/480.png
// module id = 2418
// module chunks = 2